import { render, staticRenderFns } from "./CustomerFormFields.vue?vue&type=template&id=0c315542&scoped=true&"
import script from "./CustomerFormFields.vue?vue&type=script&lang=js&"
export * from "./CustomerFormFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormFields.vue?vue&type=style&index=0&id=0c315542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c315542",
  null
  
)

export default component.exports